import createBadgeAppearance from './createBadgeAppearance'
import createButtonAppearance from './createButtonAppearance'
import createCheckboxAppearance from './createCheckboxAppearance'
import createInputAppearance from './createInputAppearance'
import createTagInputAppearance from './createTagInputAppearance'
import createSelectAppearance from './createSelectAppearance'
import createLinkAppearance from './createLinkAppearance'
import createTabAppearance from './createTabAppearance'
import createTextDropdownButtonAppearance from './createTextDropdownButtonAppearance'
import createRowAppearance from './createRowAppearance'
import createSegmentedControlRadioAppearance from './createSegmentedControlRadioAppearance'
import createSwitchAppearance from './createSwitchAppearance'
import createTableCellAppearance from './createTableCellAppearance'

/**
 * Themer is an object with a set of functions for creating custom themes.
 */
export default {
  createBadgeAppearance,
  createButtonAppearance,
  createCheckboxAppearance,
  createInputAppearance,
  createTagInputAppearance,
  createSelectAppearance,
  createLinkAppearance,
  createTabAppearance,
  createTextDropdownButtonAppearance,
  createRowAppearance,
  createSegmentedControlRadioAppearance,
  createSwitchAppearance,
  createTableCellAppearance
}
